import { RootState } from '../../types.ts';

export const selectReferenceBarUI = (state: RootState) => state.referenceBarUI;
